import { useEffect, useId, useRef } from 'react';
import { t } from '../i18n/nl.js';

// Toetsenbordbediening en dialogsemantiek zijn hier centraal geregeld, zodat
// elke bevestiging in de portal dezelfde toegankelijkheid heeft:
//  • role="dialog" + aria-modal + aria-labelledby/-describedby;
//  • Escape sluit (modals sluiten bewust NOOIT op een backdrop-klik);
//  • focus springt bij openen naar de bevestigknop en keert bij sluiten
//    terug naar het element dat de modal opende;
//  • Tab blijft binnen de dialoog.
export default function ConfirmModal({
  title,
  body,
  onConfirm,
  onClose,
  confirmLabel,
  danger = false,
  confirmDisabled = false,
}) {
  const dialogRef = useRef(null);
  const confirmRef = useRef(null);
  const vorigeFocusRef = useRef(null);
  const titelId = useId();
  const bodyId = useId();

  useEffect(() => {
    vorigeFocusRef.current = document.activeElement;
    confirmRef.current?.focus();
    const teruggeven = vorigeFocusRef.current;
    return () => {
      if (teruggeven && typeof teruggeven.focus === 'function') teruggeven.focus();
    };
  }, []);

  function handleKeyDown(e) {
    if (e.key === 'Escape') {
      e.stopPropagation();
      onClose?.();
      return;
    }
    if (e.key !== 'Tab') return;

    const focusbaar = dialogRef.current?.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusbaar || focusbaar.length === 0) return;
    const eerste = focusbaar[0];
    const laatste = focusbaar[focusbaar.length - 1];

    if (e.shiftKey && document.activeElement === eerste) {
      e.preventDefault();
      laatste.focus();
    } else if (!e.shiftKey && document.activeElement === laatste) {
      e.preventDefault();
      eerste.focus();
    }
  }

  return (
    <div className="modal-overlay">
      <div
        ref={dialogRef}
        className="modal"
        style={{ maxWidth: 480 }}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titelId}
        aria-describedby={bodyId}
        onKeyDown={handleKeyDown}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title" id={titelId}>{title}</h2>
          <button className="modal-close" onClick={onClose} aria-label={t('facturen.annuleren')}>✕</button>
        </div>
        <div id={bodyId} style={{ marginBottom: 24, color: 'var(--color-text-muted)', lineHeight: 1.6 }}>
          {body}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button className="btn btn-ghost" onClick={onClose}>{t('facturen.annuleren')}</button>
          <button
            ref={confirmRef}
            className="btn btn-primary"
            style={danger ? { background: '#dc2626', borderColor: '#dc2626', color: '#fff' } : {}}
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel || t('facturen.bevestigen')}
          </button>
        </div>
      </div>
    </div>
  );
}
